import { Logger } from '@futrli/shared-services';

import { businessTypeMetaData, INTERNAL_BUSINESS_TYPE, METADATA_FIELD, PENDO_RANDOM_ID_PREFIX } from './constants';

export const isInternalUser = (email: string) => {
  return email.toLowerCase().endsWith('@sage.com') || email.toLowerCase().endsWith('@futrli.com');
};

export const isPendoTempId = (id: string) => id.indexOf(PENDO_RANDOM_ID_PREFIX) !== -1;

// Returns metadata for account
export const getAccountMetadata = () => {
  if (window.pendo && window.pendo.getSerializedMetadata) {
    const metadata = window.pendo.getSerializedMetadata()?.account;
    return metadata;
  }
  return undefined;
};

export const getPendoVisitorId = (): string | undefined => {
  if (typeof window?.pendo?.getVisitorId === 'function') {
    return window.pendo.getVisitorId();
  }
  Logger.warn('[Pendo Debug] Pendo is not ready to get Visitor ID.');
  return undefined;
};

// Function to check if the visitor ID is valid
export const checkIfVisitorIdIsValid = (): boolean => {
  const visitorId = getPendoVisitorId();
  return Boolean(visitorId && !isPendoTempId(visitorId)); // Ensure it's not a temporary ID
};

export const isPendoReady = (): boolean => {
  const pendoExists = typeof window.pendo !== 'undefined';
  const initializeExists = typeof window.pendo?.initialize === 'function';
  const updateOptionsExist = typeof window.pendo?.updateOptions === 'function';

  return pendoExists && initializeExists && updateOptionsExist;
};

// Function to update Pendo account for current visitor
export const updateVisitorAccount = (accountId: string, subscriptionState: string) => {
  if (!isPendoReady()) {
    Logger.warn('[Pendo Debug] Pendo is not ready to update visitor account.');
    return;
  }

  if (window.pendo && window.pendo.visitorId) {
    window.pendo.updateOptions({
      visitor: {
        id: window.pendo.visitorId,
        [METADATA_FIELD.BUSINESS_TYPE]: window.pendo.getSerializedMetadata()?.visitor?.[METADATA_FIELD.BUSINESS_TYPE]
      },
      account: {
        id: accountId,
        [METADATA_FIELD.SUBSCRIPTION_STATUS]: subscriptionState
      }
    });
  }
};

// Function to update Pendo visitor
export const updatePendoUser = (userId: string, email: string, businessType: string): void => {
  if (!isPendoReady()) {
    Logger.warn('[Pendo Debug] Pendo is not ready to update the user.');
    return;
  }
  Logger.info('[Pendo Debug] Updating Pendo user');
  window.pendo.updateOptions({
    visitor: {
      id: userId,
      [METADATA_FIELD.BUSINESS_TYPE]: isInternalUser(email)
        ? INTERNAL_BUSINESS_TYPE
        : businessTypeMetaData[businessType] || INTERNAL_BUSINESS_TYPE
    }
  });
};
